/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var $window = $(window);
	var breakPoint = 1024;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	
	//ローディング
	
	(0, _module.loading)();
	
	//ページTOP
	
	(0, _module.pageTop)();
	
	//ヘッダーの開閉
	
	(0, _module.headerToggle)();
	
	//ページ内リンクのアニメーション
	
	(0, _module.anchorScroll)();
	
	// preload
	
	(0, _module.preload)();
	
	// resizing
	
	(0, _module.resizing)();
	
	// アニメーション
	
	(0, _module.animationFire)();
	
	// YouTubeのモーダル
	
	(0, _module.youtubeModal)();
	
	// ページ下部のキャラランダム表示
	
	(0, _module.bottomCharaRandom)();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $window = $(window);
	// const breakPoint = 767;
	var breakPoint = 1199;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	
	var url = location.href;
	
	//ローディング
	var loading = function loading() {
	  $(window).on('load', function () {
	    $("#loading").addClass("loaded");
	  });
	};
	
	//ヘッダーの開閉
	var headerToggle = function headerToggle() {
	  //toggle
	  var $header = $('.st-Header');
	  var $headerTrigger = $('.st-Header_Hamburger');
	  $headerTrigger.each(function () {
	    $(this).on('click', function () {
	      $header.toggleClass('opened');
	      // $headerNavi.slideToggle(300, 'swing');
	      return false;
	    });
	  });
	};
	
	//ページTOP
	var pageTop = function pageTop() {
	  var topBtn = $('.sw-PageTop');
	  topBtn.css({ visibility: 'hidden', opacity: 0 });
	  $(window).scroll(function () {
	    if ($(this).scrollTop() > 100) {
	      topBtn.css({ visibility: 'visible', opacity: 1 });
	    } else {
	      topBtn.css({ visibility: 'hidden', opacity: 0 });
	    }
	  });
	  topBtn.click(function () {
	    $('body,html').animate({
	      scrollTop: 0
	    }, 1000);
	    return false;
	  });
	};
	
	//外部ページからのアンカー
	var externalAnchor = function externalAnchor() {
	  $(window).on('load', function () {
	
	    var url = $(location).attr('href');
	    if (url.indexOf("?id=") == -1) {} else {
	      var url_sp = url.split("?id=");
	      var hash = '#' + url_sp[url_sp.length - 1];
	      var tgt = $(hash);
	      var pos = void 0;
	      if (windowWidth > breakPoint) {
	        if ($('body').hasClass('character')) {
	          pos = tgt.offset().top - windowWidth * 0.046875;
	        } else {
	          pos = tgt.offset().top;
	        }
	      } else {
	        pos = tgt.offset().top - windowWidth * 0.17578125;
	      }
	      $("html, body").animate({
	        scrollTop: pos
	      }, 1000, "swing");
	    }
	  });
	};
	
	//ページ内リンクのアニメーション
	var anchorScroll = function anchorScroll() {
	  var $anchor = $('a[href^=#]');
	  $anchor.click(function () {
	    var speed = 1000;
	    var href = $(this).attr('href');
	    var target = $(href == '#' || href == '' ? 'html' : href);
	    var position = target.offset().top;
	    if (windowWidth > breakPoint) {
	      position = target.offset().top;
	    } else {
	      position = target.offset().top - windowWidth * 0.17578125;
	    }
	    $('html, body').animate({
	      scrollTop: position
	    }, speed, 'swing');
	    return false;
	  });
	};
	
	// preload
	var preload = function preload() {
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	};
	
	// resizing
	var resizing = function resizing() {
	  var timer = 0;
	  $(window).on('resize', function () {
	    $("body").addClass("resizing");
	    if (timer > 0) {
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function () {
	      $("body").removeClass("resizing");
	      console.log('window resized');
	    }, 100);
	  });
	};
	
	// アニメーション
	var animationFire = function animationFire() {
	  $(".js-Animation").each(function () {
	
	    var animationFlag = false;
	    var $target = $(this);
	
	    $(window).on('load scroll', function () {
	      setTimeout(function () {
	        var winScroll = $(window).scrollTop();
	        var winHeight = $(window).height();
	        var scrollPositon = winScroll + winHeight;
	
	        if ($target.offset().top < scrollPositon) {
	          if (!animationFlag) {
	
	            animationFlag = true;
	
	            $target.addClass("animated");
	          }
	        }
	      }, 500);
	    });
	  });
	};
	
	//YouTubeのモーダル
	var youtubeModal = function youtubeModal() {
	  var $modal = $('.sw-Movie_Modal');
	  var $content = $('.sw-Movie_Modal-Content');
	  var $youtube = $('.js-Youtube');
	  // open
	  $youtube.on('click', function () {
	    var dataID = $(this).attr('data-youtube');
	    //iframe append
	    $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
	    // fadeIn
	    $modal.stop().fadeIn(400);
	    return false;
	  });
	  //close
	  $('.sw-Movie_Modal-Overlay,.sw-Movie_Modal-Close').on('click', function () {
	    $modal.stop().fadeOut(400, function () {
	      $content.children('iframe').remove();
	    });
	  });
	};
	
	//ページ下部のキャラランダム表示
	var bottomCharaRandom = function bottomCharaRandom() {
	
	  var target = document.getElementById('randamChara');
	  var charaArray = ['kasumi', 'tae', 'rimi', 'saaya', 'arisa'];
	  var charaLengrh = charaArray.length;
	  var random = Math.floor(Math.random() * charaLengrh);
	  var className = charaArray[random];
	
	  target.classList.add(className);
	};
	
	//export
	exports.loading = loading;
	exports.headerToggle = headerToggle;
	exports.pageTop = pageTop;
	exports.externalAnchor = externalAnchor;
	exports.anchorScroll = anchorScroll;
	exports.preload = preload;
	exports.resizing = resizing;
	exports.animationFire = animationFire;
	exports.youtubeModal = youtubeModal;
	exports.bottomCharaRandom = bottomCharaRandom;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// special/app.bundle.js